import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "input"]

  connect() {
    // Hide custom input initially
    this.hideCustomInput()
    // Set initial state when controller connects (for edit forms)
    this.setInitialState()
  }

  setInitialState() {
    const currentValue = this.inputTarget.value

    if (currentValue) {
      // Try to find a matching preset button
      const matchingButton = this.buttonTargets.find(btn => btn.dataset.minutes === currentValue)

      if (matchingButton) {
        this.activateButton(matchingButton)
        this.hideCustomInput()
      } else {
        // Custom value - highlight custom button and show input
        const customButton = this.buttonTargets.find(btn => btn.dataset.minutes === 'custom')
        if (customButton) {
          this.activateButton(customButton)
          this.showCustomInput()
        }
      }
    } else {
      // No value - highlight "No Limit"
      const noLimitButton = this.buttonTargets.find(btn => btn.dataset.minutes === '0')
      if (noLimitButton) {
        this.activateButton(noLimitButton)
        this.hideCustomInput()
      }
    }
  }

  hideCustomInput() {
    this.inputTarget.style.display = 'none'
  }

  showCustomInput() {
    this.inputTarget.style.display = 'block'
  }

  activateButton(button) {
    button.classList.remove('border-gray-300', 'hover:bg-gray-50')
    button.classList.add('bg-indigo-600', 'text-white', 'border-indigo-600')
  }

  deactivateAllButtons() {
    this.buttonTargets.forEach(btn => {
      btn.classList.remove('bg-indigo-600', 'text-white', 'border-indigo-600')
      btn.classList.add('border-gray-300', 'hover:bg-gray-50')
    })
  }

  selectPreset(event) {
    event.preventDefault()

    const clickedButton = event.currentTarget
    const minutes = clickedButton.dataset.minutes

    // Remove active state from all buttons
    this.deactivateAllButtons()

    // Add active state to clicked button
    this.activateButton(clickedButton)

    // Update the input field and visibility
    if (minutes === 'custom') {
      this.showCustomInput()
      this.inputTarget.focus()
      this.inputTarget.placeholder = 'Enter custom minutes'
    } else {
      this.hideCustomInput()
      if (minutes === '0') {
        this.inputTarget.value = ''
      } else {
        this.inputTarget.value = minutes
      }
    }
  }

  inputChanged() {
    // Reset button states when user types in custom field
    this.deactivateAllButtons()

    // Always highlight custom button when user is typing
    const customButton = this.buttonTargets.find(btn => btn.dataset.minutes === 'custom')
    if (customButton) {
      this.activateButton(customButton)
    }
  }
}
